import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function FAQ() {
  const [faq, setFaq] = useState([]);
  useEffect(() => {
    api.get("/faq").then((r) => setFaq(r.data)).catch(() => {});
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="section bg-bone">
      <div className="container-max grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-4">
          <p className="overline">— Questions</p>
          <h2 className="font-display font-light text-5xl md:text-6xl leading-[0.95] tracking-tighter mt-6">
            Tout ce que<br />
            vous voulez<br />
            <em className="italic text-terracotta">savoir</em>.
          </h2>
          <p className="mt-6 text-ink/70 max-w-sm">Une question manque ? Écrivez-nous directement, nous répondons en moins de 24h ouvrées.</p>
        </div>

        <div className="col-span-12 md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faq.map((q, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-ink/20"
              >
                <AccordionTrigger className="text-left font-display text-xl md:text-2xl hover:no-underline py-6">
                  {q.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/75 text-base md:text-lg leading-relaxed pb-6">
                  {q.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
